import { useMutation } from "react-query";
import { getFreshAccessToken } from "../use-user";

export const useCreateInStoreShipping = (mutationOptions = {}) => {
  return useMutation({
    mutationFn: async (input) => {
      const accessToken = getFreshAccessToken();

      const response = await fetch("/api/shipping/generate-in-store-shipping", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ input }),
      });

      const result = await response.json();

      if (!response.ok || result.error) {
        throw new Error(result.error || "Failed to create in-store shipping");
      }

      return result;
    },
    ...mutationOptions,
  });
};
